import { useCollection } from '../hooks/useCollection';
import { useSelector } from 'react-redux';

export const useAllTrainingDays = () => {
    const allUsers = useSelector((state) => state.user.allUsers)
    const { data: trainingDays, keys: userIds } = useCollection('/TrainingDays')

    var allTrainingDays = []
    userIds && userIds.map((u, idx) => {
        if (allUsers.find(usr => usr.email.replaceAll(".", "") === u.childKey)) {
            const tdays = trainingDays[idx]
            const tDay = {
                userId: u.childKey,
                tDays: Object.values(tdays)
            }
            allTrainingDays.push(tDay)
        }
        return null
    })

    return { allTrainingDays }

}
